import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// FIX RIUNIONI 2026-11-02: timeout di default 10s su tutte le chiamate axios
// per evitare spinner infiniti quando il pod è sospeso/non raggiungibile.
// L'upload documenti (multipart) continua a usare timeout 60s per file grandi.
export const DEFAULT_TIMEOUT_MS = 10000;

function readCookie(name) {
    const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
}

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
    timeout: DEFAULT_TIMEOUT_MS,
});

api.interceptors.request.use((config) => {
    const method = (config.method || "get").toLowerCase();
    // Multipart (upload) richiede timeout più lungo
    const isMultipart =
        config.headers?.["Content-Type"] === "multipart/form-data" ||
        config.data instanceof FormData;
    if (isMultipart && (!config.timeout || config.timeout < 60000)) {
        config.timeout = 60000;
    }
    if (["post", "put", "patch", "delete"].includes(method)) {
        const csrf = readCookie("enerleft_csrf");
        if (csrf) {
            config.headers = { ...(config.headers || {}), "X-CSRF-Token": csrf };
        }
    }
    return config;
});

/**
 * `isUnreachableError(err)` — true quando l'errore axios è un timeout o
 * network error (pod sospeso, DNS failure, ecc.). Il flow frontend deve
 * mostrare un toast "Servizio non raggiungibile" + bottone Riprova invece
 * di loop infinito o errore generico.
 */
export function isUnreachableError(err) {
    if (!err) return false;
    if (err.code === "ECONNABORTED") return true;              // timeout
    if (err.message && err.message.includes("timeout")) return true;
    if (!err.response) return true;                            // network error puro
    if (err.response.status === 503) return true;              // service unavailable
    return false;
}
